/* @flow */

import { SectionType } from '../../../../helpers/ui/section/types';
import { type NETGEM_API_V8_AGGREGATION_FEED } from './AggregationFeed';
import { type NETGEM_API_V8_NTG_VIDEO_FEED } from './NtgVideoFeed';
import { type NETGEM_API_V8_WIDGET } from './Widget';

export const LocalFeed = Object.freeze({
  Channels: 'channels/list',
  PlayingHistory: 'playinghistory',
  ViewingHistory: 'viewinghistory',
  Wishlist: 'wishlist',
});

export type SectionModelUnionType = NETGEM_API_V8_NTG_VIDEO_FEED | NETGEM_API_V8_AGGREGATION_FEED;

export type NETGEM_API_V8_SECTION = {
  ...NETGEM_API_V8_WIDGET,
  kind: SectionType,
  model: SectionModelUnionType,
  version: number,
};
